// LEGACY UI: replace with Button from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).

import useSite from "@casino/legacy/client/hooks/useSite";
import ButtonComponent from "@casino/legacyUi/Button";
import type ButtonSettingsProps from "@casino/legacyUi/Button/types/SettingsProps";
import { cn } from "@workspace/frontend-ui";
import type { HTMLProps } from "react";

type Props = Omit<HTMLProps<HTMLButtonElement>, "size"> &
  ButtonSettingsProps & {
    className?: string;
    as?: "a" | "button" | "span";
  };

const Button: FC<Props> = ({
  children,
  className,
  variant = "primary",
  ...props
}) => {
  const { isBitcasino, isSportsbet } = useSite();
  return (
    <ButtonComponent
      data-testid="tw-button"
      className={cn(
        (isBitcasino || isSportsbet) &&
          variant === "tertiary" &&
          "text-foreground",
        className,
      )}
      variant={variant}
      {...props}
    >
      {children}
    </ButtonComponent>
  );
};

export default Button;
